import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef, inject } from '@angular/core';
import { iconArrowDown } from '@knorr-bremse-portals/icons';
import { Speed } from '@knorr-bremse-portals/ngx-components';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { VariableHeadingComponent } from '@knorr-bremse-portals/ngx-components/components/variable-heading';

/**
 * Control IDs need to be unique across components, so this counter exists outside of
 * the component definition.
 */
let _uniqueIdCounter = 0;

const expandCollapse = trigger('expandCollapse', [
  state('*', style({
    height: '0',
  })),
  state('expanded', style({
    height: '*',
  })),
  state('collapsed', style({
    height: '0',
    display: 'none',
  })),
  transition('* => *', [
    style({
      display: '*',
    }),
    animate(Speed.Fast),
  ]),
]);

@Component({
  selector: 'kb-accordion-panel',
  templateUrl: './accordion-panel.component.html',
  styleUrls: ['./accordion-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [expandCollapse],
  standalone: true,
  imports: [ VariableHeadingComponent, IconComponent ],
})
export class AccordionPanelComponent {

  @Input()
  public headingLevel: 2 | 3 | 4 | 'none' = 3;

  private readonly uniqueId = `${_uniqueIdCounter++}`;
  protected readonly panelHeaderId = `kb-accordion-panel-header-${this.uniqueId}`;
  protected readonly panelContentId = `kb-accordion-panel-content-${this.uniqueId}`;

  protected iconArrowDown = iconArrowDown;

  @Output()
  public readonly expand = new EventEmitter<void>();

  @Input()
  public set expanded(expanded: boolean) {
    this._expanded = expanded;
    if (this.expanded) {
      this.expand.emit();
    }
    this.cdr.markForCheck();
  }
  public get expanded(): boolean {
    return this._expanded;
  }
  private _expanded = false;

  private cdr = inject(ChangeDetectorRef);

  public toggle() {
    this.expanded = !this.expanded;
  }

}
